import { useIntl } from "react-intl";

// Material UI Components
import { Button, ButtonProps, Theme, CircularProgress } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

// Components
import CustomIcon from "components/CustomIcon";

// Others
import icons from "enums/icons";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            minWidth: "auto",
            padding: theme.spacing(1.5, 2.5),
            "&.MuiButton-outlined": {
                "&.Mui-disabled": {
                    color: theme.palette.text.disabled,
                    borderColor: theme.palette.button.deactivated,
                    "& .MuiButton-startIcon": {
                        color: theme.palette.button.deactivated,
                    },
                },
            },
            "& . MuiButton-sizeSmall": {
                padding: theme.spacing(1),
            },
            "& .MuiButton-startIcon": {
                marginRight: theme.spacing(1),
            },
            "& .MuiButton-endIcon": {
                marginLeft: theme.spacing(1),
            },
            "& .MuiSvgIcon-root": {
                fontSize: `14px !important`,
            },
        },
    })
);

export interface NavButtonProps extends ButtonProps {
    icon?: JSX.Element | null;
    translationId?: string;
    isBackButton?: boolean;
    showBackArrow?: boolean;
    showLoader?: boolean;
}

const NavButton = ({
    translationId,
    icon,
    isBackButton,
    children,
    showBackArrow = true,
    showLoader = false,
    ...otherProps
}: NavButtonProps): JSX.Element => {
    const intl = useIntl();
    const classes = useStyles();

    return (
        <Button
            className={classes.button}
            variant={isBackButton ? "text" : "contained"}
            color="primary"
            {...(isBackButton
                ? showBackArrow
                    ? {
                          startIcon: icon ? icon : <CustomIcon type="outlined" icon={icons.chevronLeftThin} />,
                      }
                    : {}
                : icon !== null && !otherProps?.startIcon
                ? {
                      endIcon: icon ? (
                          icon
                      ) : showLoader ? null : (
                          <CustomIcon type="outlined" icon={icons.chevronRightThin} />
                      ),
                  }
                : {})}
            {...otherProps}
        >
            {showLoader ? (
                <CircularProgress size={16} sx={{ color: "common.white" }} />
            ) : (
                children ||
                intl.formatMessage({
                    id: translationId || (isBackButton ? "button.back" : "button.next"),
                })
            )}
        </Button>
    );
};

export default NavButton;
